import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

export interface IDeleteDocumentInterventionRequestAction {
  data: {
    file_type: string;
    id: number | undefined;
    intervention_document_id: number;
  };
  functions: {
    close: () => void;
    error: (err: any) => void;
  };
}

function deleteDocumentRequest(
  draft: Draft<IInterventionData>,
  _: PayloadAction<IDeleteDocumentInterventionRequestAction>,
) {
  draft.deleteDocument.config.isLoading = true;
}

export default deleteDocumentRequest;
